/* @flow */

import { isArray } from '@e180/util/lib/type';

import avatarSizes from './setting/avatarSizes';
import { retina } from 'src/shared/app/base/style/token/helper';
import { aaDarkGrey, lightGrey } from '@e180/ui/lib/token/palette';

let styles = {
  root: {
    width: '100%',
    height: '100%',

    backgroundColor: aaDarkGrey,
    borderRadius: '50%',
  },
  'root-isGroup': {
    display: 'flex',
    flexDirection: 'row',

    backgroundColor: 'inherit',
  },
  left: (props: Object) => {
    let extraProps = {};

    if (props) {
      const { leftSrc } = props;

      if (isArray(leftSrc) && leftSrc.length > 0) {
        extraProps = retina(leftSrc);
      }
    }

    return {
      position: 'relative',
      right: 1,

      width: '50%',
      height: '100%',

      backgroundColor: lightGrey,
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      ...extraProps,
    };
  },
  right: {
    position: 'relative',
    left: 1,

    display: 'flex',
    flexDirection: 'column',

    width: '50%',
    height: '100%',
  },
  top: (props: Object) => {
    let extraProps = {};

    if (props) {
      const { topSrc } = props;

      if (isArray(topSrc) && topSrc.length > 0) {
        extraProps = retina(topSrc);
      }
    }

    return {
      width: '100%',
      height: 'calc(50% - 1px)',
      marginBottom: 1,

      backgroundColor: lightGrey,
      backgroundSize: 'cover',
      backgroundPosition: 'center center',
      backgroundRepeat: 'no-repeat',
      ...extraProps,
    };
  },
  bottom: (props: Object) => {
    let extraProps = {};

    if (props) {
      const { bottomSrc } = props;

      if (isArray(bottomSrc) && bottomSrc.length > 0) {
        extraProps = retina(bottomSrc);
      }
    }

    return {
      width: '100%',
      height: 'calc(50% - 1px)',
      marginTop: 1,

      backgroundColor: lightGrey,
      backgroundPosition: 'center center',
      backgroundSize: 'cover',
      backgroundRepeat: 'no-repeat',
      ...extraProps,
    };
  },
};

for (const [key, size] of Object.entries(avatarSizes)) {
  styles = {
    ...styles,
    [`root-${key}`]: {
      width: size,
      height: size,
    },
    [`left-${key}`]: {
      borderTopLeftRadius: Number(size) / 2,
      borderBottomLeftRadius: Number(size) / 2,
    },
    [`right-${key}`]: {
      borderTopRightRadius: Number(size) / 2,
      borderBottomRightRadius: Number(size) / 2,
    },
    [`bottom-${key}`]: {
      borderBottomRightRadius: Number(size) / 2,
    },
    [`top-${key}`]: {
      borderTopRightRadius: Number(size) / 2,
    },
  };
}

export default styles;
